/**
 * Router state a page passes when it sends the user to /login after a password
 * reset. It travels in the history entry rather than the URL, and the login page
 * clears it once shown, so neither a shared link nor a reload replays it.
 */
export const PASSWORD_RESET_NOTICE = { notice: "password_reset" } as const;

/** True when `state` (a location's router state) carries the reset notice. */
export function hasPasswordResetNotice(state: unknown): boolean {
  return (state as { notice?: unknown } | null)?.notice === PASSWORD_RESET_NOTICE.notice;
}
